import(/* webpackMode: "eager" */ "/vercel/path0/apps/getxobelaeskola-web/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/getxobelaeskola-web/src/components/cookies/AnalyticsConsentGate.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/getxobelaeskola-web/src/components/cookies/CookieBanner.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/getxobelaeskola-web/src/components/cookies/CookieConsentContext.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/getxobelaeskola-web/src/components/cookies/CookieFooterTrigger.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/getxobelaeskola-web/src/components/cookies/CookieSettingsModal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/getxobelaeskola-web/src/components/layout/ConditionalLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/getxobelaeskola-web/src/components/layout/FooterWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/getxobelaeskola-web/src/components/layout/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FramerProvider"] */ "/vercel/path0/apps/getxobelaeskola-web/src/components/providers/FramerProvider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/getxobelaeskola-web/src/components/shared/AccessibilityScript.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/getxobelaeskola-web/src/components/shared/CollaboratorsGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/getxobelaeskola-web/src/components/shared/HomeStats.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/getxobelaeskola-web/src/components/shared/Newsletter.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/getxobelaeskola-web/src/components/shared/ScrollManager.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/getxobelaeskola-web/src/components/shared/ScrollToTop.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/getxobelaeskola-web/src/components/shared/StatusToast.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/getxobelaeskola-web/src/components/shared/WhatsAppButton.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/getxobelaeskola-web/src/styles/tokens.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/app/fonts.ts\",\"import\":\"Cormorant_Garamond\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-display\",\"weight\":[\"300\",\"400\",\"600\"],\"style\":[\"normal\",\"italic\"]}],\"variableName\":\"cormorantGaramond\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/app/fonts.ts\",\"import\":\"Outfit\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-sans\",\"weight\":[\"300\",\"400\",\"600\"]}],\"variableName\":\"outfit\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/app/fonts.ts\",\"import\":\"JetBrains_Mono\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-mono\",\"weight\":[\"300\",\"400\",\"700\"]}],\"variableName\":\"jetbrainsMono\"}");
